export interface ChatbotState {
	clearHistory: boolean;
	sessionId: string;
}
